module.exports = __webpack_public_path__ + "static/media/register.2296102e.gif";